<fd-tab-list size="s">
  <fd-tab [title]="themeTabTitle()">
    <ul fd-list [byline]="true">
      @for (theme of themes; track theme.id) {
        <li
          fd-list-item
          [selected]="theme.id === selectedTheme"
          (keyup.enter)="selectTheme(theme.id)"
          (keyup.space)="selectTheme(theme.id)"
        >
          <a fd-list-link (click)="selectTheme(theme.id)">
            <span fd-list-thumbnail>
              <svg
                data-name="Layer 1"
                id="Layer_1"
                viewBox="0 0 200 200"
                xmlns="http://www.w3.org/2000/svg"
                [class]="theme.id"
              >
                <defs>
                  <style>
                    .cls-1 {
                      fill: #1c2228;
                    }
                    .cls-2 {
                      fill: #424f5e;
                    }
                    .cls-3 {
                      fill: #29313a;
                    }
                    .cls-4 {
                      fill: #3a4552;
                    }
                    .cls-5 {
                      fill: #91c8f6;
                    }
                    .cls-6 {
                      fill: #d3d7d9;
                    }
                    .cls-7 {
                      fill: #354a5f;
                    }
                    .cls-8 {
                      fill: #7996b4;
                    }
                    .cls-9 {
                      fill: #fff;
                    }
                  </style>
                </defs>
                <rect class="cls-1" height="112" width="200" y="88" />
                <path class="cls-2" d="M200,105v95H59V110a5,5,0,0,1,5-5Z" />
                <path
                  class="cls-3"
                  d="M64,106H200v94H60V110A4,4,0,0,1,64,106Z"
                />
                <rect class="cls-3" height="44" width="200" y="44" />
                <rect class="cls-4" height="1" width="200" y="87" />
                <path
                  class="cls-5"
                  d="M64,63h46a5,5,0,0,1,5,5h0a5,5,0,0,1-5,5H64a5,5,0,0,1-5-5h0A5,5,0,0,1,64,63Z"
                />
                <path
                  class="cls-6"
                  d="M153,63h47V73H153a5,5,0,0,1-5-5h0A5,5,0,0,1,153,63Z"
                />
                <path
                  class="cls-5"
                  d="M62,85h50a3,3,0,0,1,3,3H59A3,3,0,0,1,62,85Z"
                />
                <rect class="cls-7" height="44" width="200" />
                <path
                  class="cls-8"
                  d="M68.459,13a1,1,0,0,1,.714,1.707l-16.155,16A1.01,1.01,0,0,1,52.3,31H33.539a1,1,0,0,1-1.01-.99V14a1,1,0,0,1,1-1h34.93m0-3H33.539A4.024,4.024,0,0,0,29.5,14V30a4.024,4.024,0,0,0,4.039,4H52.3a4.033,4.033,0,0,0,2.857-1.172l16.154-16a3.961,3.961,0,0,0,.876-4.359A4.027,4.027,0,0,0,68.459,10Z"
                />
                <rect
                  class="cls-9"
                  height="10.101"
                  rx="5"
                  width="75.758"
                  x="82.121"
                  y="16.949"
                />
                <path
                  class="cls-9"
                  d="M170,18h30v8H170a4,4,0,0,1-4-4h0A4,4,0,0,1,170,18Z"
                />
              </svg>
            </span>
            <div fd-list-content>
              <div fd-list-title>{{ theme.name }}</div>
              <div fd-list-byline>{{ theme.description }}</div>
            </div>
          </a>
        </li>
      }
    </ul>
  </fd-tab>
</fd-tab-list>
